import { cookies } from '@/lib/api/cookies';
import { getLanguageFromLocation } from '@/helpers/getLanguageFromLocation';
import { betslipTabs, defaultLanguage } from '@/config/constants';

const language = getLanguageFromLocation();

const lobbyViewCooky = cookies.get('cyberLobbyView');
const sportViewCooky = cookies.get('sportLobbyView');
const mainViewCooky = cookies.get('mainLobbyView');

const cyberLobbyView = lobbyViewCooky ? +lobbyViewCooky : 1;
const sportLobbyView = sportViewCooky ? +sportViewCooky : 0;
const mainLobbyView = mainViewCooky ? +mainViewCooky : 0;

const ui = {
  betSlipOpen: false,
  cyberLobbyView,
  defaultLanguage,
  disciplinesIsSport: 'lobby',
  isVip: false,
  language,
  lobbyFilters: {
    country: null,
    date: null,
    disciplines: [],
    lines: [],
    tournament: null,
  },
  mainLobbyView,
  playVideo: false,
  quickBetFlag: true,
  quickBetIsOpen: false,
  showVideosList: false,
  sportLobbyView,
  video: null,
};

const betslip = {
  acceptChanges: true,
  betStatuses: [],
  bets: [],
  currentTab: betslipTabs[0],
  errors: [],
  inProgress: false,
  maxDelay: null,
  notices: {
    comboOutrights: false,
    duplicates: false,
  },
  pendingBets: [],
};

const defaultState = {
  disciplines: new Map(),
  events: new Map(),
  lines: new Map(),
  markets: new Map(),
  outcomes: new Map(),
  outrights: new Map(),
  scheduleDisciplines: [],
  slides: [],
  tournaments: new Map(),
};

const authError = {
  code: null,
  description: '',
  meta: {
    time: null,
  },
};
const defaultAuth = {
  errors: {
    joinError: authError,
    loginError: authError,
    recoveryError: authError,
    renewError: authError,
    resendError: authError,
  },
  isLogged: false,
  token: '',
  userData: {
    address: '',
    birthday: null,
    city: '',
    country: '',
    currencyId: null,
    email: '',
    firstName: '',
    gender: '',
    id: null,
    intercomHash: null,
    isDocsVerified: false,
    isEmailVerified: true,
    isRulesConfirmed: false,
    isTest: false,
    lastName: '',
    phoneNumber: '',
    postCode: '',
    selfExcludedEnd: null,
    selfExcludedStart: null,
    steamId: '',
    verification: 0,
  },
};

const defaultWallet = {
  balance: [],
  playerId: null,
};

export const initialStore = {
  auth: defaultAuth,
  betslip,
  store: defaultState,
  ui,
  wallet: defaultWallet,
} as const;
